import { atom, useAtom, useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { authService } from '@/services';
import { isAuthenticatedAtom, currentUserAtom } from './use-auth';
import type { UserAccountDto } from '@/types';

const userAccountsAtom = atomWithQuery((get) => ({
  queryKey: ['auth', 'user-accounts'],
  queryFn: authService.getUserAccounts,
  staleTime: 5 * 60 * 1000,
  enabled: get(isAuthenticatedAtom),
}));

/** The account selected in the app: the signed-in user's, else the one the user-accounts list marks current. */
export const currentAccountIdAtom = atom((get): number | null => {
  const currentUser = get(currentUserAtom);
  return currentUser?.accountId != null
    ? Number(currentUser.accountId)
    : (get(userAccountsAtom).data?.currentAccountId ?? null);
});

export const useUserAccounts = () => {
  const [{ data, isLoading, isError }] = useAtom(userAccountsAtom);
  const currentAccountId = useAtomValue(currentAccountIdAtom);

  const accounts = (data?.accounts ?? []) as UserAccountDto[];

  return { accounts, currentAccountId, isLoading, isError };
};
